import React, { useState } from "react";

import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  main: {
    top: "20%",
    left: "50%",
    marginLeft: -125,
    border: "2px solid",
    display: "grid",
    justifyContent: "center",
    flexWrap: "wrap",
    width: 250,
    marginTop: 10,
    height: 350,
    padding: 5,
    position: "absolute",
  },
  input: {
    width: 210,
    height: 30,
    border: "none",
    borderBottom: "2px solid",
  },

  submit: {
    margin: 5,
    width: 210,
    height: 30,
    alignItems: "center",
  },
}));

const FormInput = ({ toggleManager }) => {
  const [credential, setCredential] = useState({ username: "", password: "" });
  const classes = useStyles();
  const { username, password } = credential;

  const handelChange = (event) => {
    const { name, value } = event.target;
    console.log(name, value, event);
    setCredential({ ...credential, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (username === "unoMe" && password === "123") {
      // alert("Welcome back " + username);
      toggleManager();
    } else {
      console.log(username, password, typeof username, typeof password);
      alert("Opppps...wrong");
    }
  };

  return (
    <div>
      <div>
        <form onSubmit={handleSubmit} className={classes.main}>
          <h1>Admin's Zone</h1>

          <span>user name</span>

          <input
            type="text"
            name="username"
            value={username}
            onChange={handelChange}
            className={classes.input}
            placeholder="enter userName"
          />

          <span>password</span>

          <input
            type="password"
            name="password"
            value={password}
            onChange={handelChange}
            className={classes.input}
            placeholder="enter password"
          />

          <button type="submit" className={classes.submit}>
            Verify
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormInput;
